<template>
  <v-card class="px-2" color="#133063">
    <div class="tw-text-center tw-py-3 tw-mt-1 tw-relative">
      <span>SIGN IN</span>
      <v-btn class="tw-absolute tw-top-1 tw-right-0" icon @click="$emit('closeModal')">
        <v-icon dark small> mdi-close </v-icon>
      </v-btn>
    </div>

    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col>
          <v-alert
            class="tw-cursor-pointer"
            @click="errorMessage = ''"
            transition="scale-transition"
            :value="!!errorMessage"
            dense
            text
            outlined
            color="#FB8C00"
          >
            <v-row>
              <v-col class="grow tw-text-left">
                <div>
                  <ul class="tw-list-disc tw-leading-4">
                    <li>
                      <small>{{ errorMessage }}</small>
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
          </v-alert>
          <form @submit.prevent="login" action="#">
            <div class="tw-text-left tw-text-sm mb-1">Email Address</div>
            <v-text-field
              v-model="form.email"
              :rules="[rules.required, rules.email]"
              background-color="white"
              dense
              color="white"
              solo
              filled
              class="rounded-lg"
              light
            ></v-text-field>
            <div class="tw-text-left tw-text-sm mb-1">Password</div>
            <v-text-field
              v-model="form.password"
              background-color="white"
              type="password"
              color="white"
              dense
              solo
              filled
              class="rounded-lg"
              light
            ></v-text-field>
            <v-checkbox color="white" label="Remember me" dense></v-checkbox>
            <div class="mb-4">
              <v-btn
                type="submit"
                color="#d28945"
                width="100%"
                class="tw-text-white mb-2 tw-rounded-full"
                :loading="loading"
              >
                Login
              </v-btn>
              <div class="tw-flex tw-items-center tw-space-x-5 tw-text-center mb-2">
                <v-divider></v-divider>
                <div class="tw-text-sm">OR</div>
                <v-divider></v-divider>
              </div>
              <!-- <v-btn @click="loginAsFb" color="#1877f2" width="100%" class="tw-text-white rounded-lg">
                <img :src="require('@/assets/images/facebookicon.svg')" width="75" />
              </v-btn> -->

              <v-btn @click="loginAsGoogle" color="#fff" width="100%" class="tw-text-[#333] tw-rounded-full tw-mt-2">
                <img :src="require('@/assets/images/googleIcon.png')" width="58" />
              </v-btn>
            </div>
          </form>
          <div class="tw-flex tw-justify-between tw-text-xs mb-3">
            <div>
              <a href="#">Forgot Password?</a>
            </div>
            <div>
              <a href="#" @click="$emit('toRegister')">Join Now</a>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["loginModal"],
  data: () => ({
    loading: false,
    errorMessage: "",
    form: {
      email: "",
      password: "",
    },
    rules: {
      required: (value) => !!value || "Required.",
      email: (v) => /.+@.+\..+/.test(v) || "Please specify valid email",
    },
  }),
  methods: {
    ...mapActions("user", ["attemptLogin"]),
    async login() {
      this.loading = true;
      const response = await this.attemptLogin(this.form);
      if (response.data) {
        if (response.data.success) {
          return location.reload();
        }
        this.errorMessage = response.data.error;
      }
      this.loading = false;
    },
    formCheck() {
      if (!this.form.email || !this.form.password) {
        return (this.errorMessage = "Please specify empty fields");
      }
    },
    loginAsFb() {
      location.href = process.env.VUE_APP_2EZ_URL + "auth/facebook?r=casino";
    },
    loginAsGoogle() {
      location.href = process.env.VUE_APP_2EZ_URL + "auth/google?r=casino";
    },
  },
};
</script>

<style></style>
